import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routes from '../../../../components/Routes/routingMap';
import { Creators as procedureActions } from '../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as proceduresCategoryActions } from '../../../../../domain/useCases/procedures/getProceduresCategory';
import constants from '../../constants';
import ProcedureListView from './ProcedureListView';
import useProfile from '@/presentation/hooks/useProfile';
import Spinner from '@/presentation/components/Spinner';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import useSelectProcedure from '@/presentation/hooks/useSelectProcedure';

const ProceduresListViewController = () => {
  const dispatch = useDispatch();
  const { academic } = useProfile();
  const params = useParams<{ categoryName: string }>();
  const history = useHistory();
  const { evalRedirect } = useSelectProcedure();
  const { data: dataAcl } = useSelector((state: any) => state.getProfileAcl);
  const [categoryName, setCategoryName] = useState<string>('');
  let procedureListFilter: any[] = []; // setProcedureListFilter] = useState<any[]>([]);
  const [proceduresWithPermissions, setProceduresWithPermissions] = useState(
    []
  );

  const { isExternalLoading } = useExternalSettings();

  const filterList = () => {
    const { categoryName: paramCategoryName } = params;

    if (paramCategoryName === 'autogestionables') {
      const combinedProcedureList = [
        ...constants.categories.requests.procedureListTemp,
        ...constants.categories.certificates.type1List,
        ...constants.categories.requests.procedureList
      ];
      // setProcedureListFilter(combinedProcedureList);
      procedureListFilter = combinedProcedureList;
      return;
    }

    if (paramCategoryName === constants.categories.scholarships.url) {
      // setProcedureListFilter([
      //   ...constants.categories.scholarships.procedureList
      // ]);
      procedureListFilter = [
        ...constants.categories.scholarships.procedureList
      ];
      return;
    }

    procedureListFilter = [];
    // setProcedureListFilter([]);
  };

  const getCategoryName = () => {
    if (params.categoryName === 'autogestionables') {
      setCategoryName('Autogestionables');
    }
    if (params.categoryName === constants.categories.scholarships.url) {
      setCategoryName('Becas y descuentos');
    }
  };

  // effetcs
  useEffect(() => {
    GoogleAnalytics.writeLog('portal-procedure-proceduresList', 'procedure');
  }, []);

  useEffect(() => {
    if (
      params.categoryName !== 'autogestionables' &&
      params.categoryName !== constants.categories.scholarships.url
    ) {
      history.push(routes.student.procedures.home);
    }
  }, [params]);

  useEffect(() => {
    document.title = `UTP + Portal | ${
      params.categoryName.slice(0, 1).toUpperCase() +
      params.categoryName.slice(1)
    }`;
    filterList();
    getCategoryName();
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, [params, isExternalLoading]);

  const [selectedProcedure, setSelectedProcedure]: any = useState(0);
  const [showExternal, setShowExternal] = useState(false);
  const [availableInApp, setAvailableInApp] = useState(false);

  const handleSelectProcedure = (procedure: any) => {
    const {
      procedureId,
      isExternal,
      availableInApp: isAvailableInApp,
      endDate,
      isTemp
    } = procedure;

    if (isExternal) {
      setShowExternal(isExternal);
      setAvailableInApp(isAvailableInApp);
      return;
    }
    setSelectedProcedure(procedureId);
    const arrDate = endDate ? endDate.split('-') : null;
    const deadline = arrDate
      ? new Date(arrDate[0], arrDate[1] - 1, arrDate[2])
      : null;
    if (!isTemp) {
      // if discount full cycle not show procedure info
      if (
        procedureId ===
        constants.categories.requests.procedures.fullCycleDiscount
      )
        return;
      dispatch(
        proceduresCategoryActions.selectProceduresCategory({
          ...procedure,
          deadline
        })
      );
      const { isGraduated } = academic;
      dispatch(
        procedureActions.getProcedureInformation(
          procedureId,
          isGraduated ? 'EGRE' : ''
        )
      );
    }
  };

  const handleCloseExternal = () => {
    setShowExternal(false);
  };

  useEffect(() => {
    if (selectedProcedure !== 0) {
      evalRedirect(selectedProcedure);
    }
  }, [selectedProcedure]);

  useEffect(() => {
    if (dataAcl && dataAcl.length > 0 && procedureListFilter.length > 0) {
      const procedureMap = new Map(
        procedureListFilter.map((item) => [item.id, item])
      );
      const filteredProcedures = dataAcl
        .filter(
          (item: any) =>
            item.page === 'Autogestionables' &&
            procedureMap.has(item.permission)
        )
        .map((item: any) => {
          const proc = procedureMap.get(item.permission);
          return {
            permission: item.permission,
            name: proc.name,
            url: proc.url,
            procedureId: proc.procedureId,
            isNew: item.isNew
          };
        });
      setProceduresWithPermissions(filteredProcedures);
    }
  }, [dataAcl, procedureListFilter]);

  if (!academic || isExternalLoading) {
    return <Spinner />;
  }

  return (
    <ProcedureListView
      availableInApp={availableInApp}
      categoryName={categoryName}
      closeExternal={handleCloseExternal}
      handleSelectProcedure={handleSelectProcedure}
      procedureListFilter={proceduresWithPermissions}
      showExternal={showExternal}
    />
  );
};

export default ProceduresListViewController;
